import { getEnvVariable } from '@/utils';

export const MAIN_SERVER_API_ORIGIN = getEnvVariable('REACT_APP_MAIN_SERVER_API_ORIGIN')